import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api, { getQrText } from '../Base/Config';
import Message from '../Components/Message/Message';
import styles from './qr-details.module.css';

export default function TextDetails(){
    const string = useParams().string;
    const [loader, setLoader] = useState(true);
    const [details, setDetails] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        fetchFunction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchFunction = () => {
        api.get(getQrText + string)
        .then(res => {
            setLoader(false);
            if(res.data.code === 200) {
                setDetails(res.data.result);
            } else {
                console.log(res);
                setMessageType('error');
                setMessage(res.data.message);
            }
        })
        .catch(err => {
            setLoader(false);
            console.error(err);
            setMessageType('error');
            setMessage('Please try again, Sorry for the trouble.');
        })
    }

    return (<>
        {message && <Message type={messageType} message={message} closeMessage={() => setMessage('')} />}
        <div className={styles['loader']}>
            {
                loader
                ?<img src="../images/loader.gif" alt="loader" style={{width:'100px'}} />
                :<div style={{padding: '20px'}}>
                    <p><b>Text:</b> {details.text}</p>
                    <p><b>Description:</b> {details.description}</p>
                </div>
            }
        </div>
    </>)
}
